/**
 * Sentry SDK bootstrap for PWA_BorneInteractive.
 * Events go to our self-hosted GlitchTip (Sentry-compatible).
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry(): void {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENV as string) || 'dev',
    release: (import.meta.env.VITE_GIT_SHA as string) || undefined,
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
  });
  Sentry.setTag('service', 'pwa-borne');
}

export { Sentry };
